import { Container, styled } from '@mui/material';

export const PasswordResetForm = styled(Container)({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '20px',
  width: '100%',
});
